import React from 'react'
import { memo } from '~/ui/component'
import HomeScreenWidgetsContextProvider from './HomeScreenWidgetContext'
import HomeScreenWidgetsBody from './HomeScreenWidgetsBody'

const HomeScreenWidgets = memo('HomeScreenWidgets', () => {

  //------
  // Rendering

  function render() {
    return(
      <HomeScreenWidgetsContextProvider>
        <HomeScreenWidgetsBody />
      </HomeScreenWidgetsContextProvider>
    )
  }

  return render()

})

export default HomeScreenWidgets